import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  CtxAlertComponent,
  CtxButtonComponent,
  CtxButtonGroupComponent,
  CtxForm,
  UNLIMITED_VALUE_MINUS_ONE,
} from 'ng-ui';
import {
  CtxValidators,
  ResourceCreateFormData,
  ResourceUpdateFormData,
} from 'utils';

@Component({
  selector: 'ctx-reseller-form',
  templateUrl: './reseller-form.component.html',
  standalone: true,
  imports: [
    MatInputModule,
    CtxButtonComponent,
    ReactiveFormsModule,
    MatTooltipModule,
    CtxButtonGroupComponent,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogModule,
    CtxAlertComponent,
  ],
})
export class ResellerFormComponent extends CtxForm implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ResourceCreateFormData | ResourceUpdateFormData,
    public dialogRef: MatDialogRef<ResellerFormComponent>,
    private fb: FormBuilder
  ) {
    super();
  }
  UNLIMITED_VALUE_MINUS_ONE = UNLIMITED_VALUE_MINUS_ONE;
  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: [
        this.getInitialControlValue('name', this.dialogData),
        Validators.maxLength(256),
      ],
      email: [
        this.getInitialControlValue('email', this.dialogData),
        Validators.email,
      ],
      description: [
        this.getInitialControlValue('description', this.dialogData),
        Validators.maxLength(256),
      ],
      allowedUsers: [
        this.getInitialControlValue('allowedUsers', this.dialogData),
        [
          Validators.required,
          Validators.min(-1),
          CtxValidators.onlyIntegers,
          CtxValidators.int32,
        ],
      ],
      allowedOrganizations: [
        this.getInitialControlValue('allowedOrganizations', this.dialogData),
        [
          Validators.required,
          Validators.min(-1),
          CtxValidators.onlyIntegers,
          CtxValidators.int32,
        ],
      ],
    });
  }
}
